import React, { useEffect, useState } from "react";
import PopupMex from "../Components/SavePopup";
import { TbLayoutSidebarLeftExpand, TbLayoutSidebarRightExpandFilled, TbList, TbLogs, TbReload } from "react-icons/tb";
import { useNavigate, useParams } from "react-router-dom";
import MandatorySign from "../Components/MandatorySign";
import { IoChevronDown, IoChevronUp, IoClose, IoReload } from "react-icons/io5";
import { BiPlay } from "react-icons/bi";
import SaveActionsModal from "./SaveActionsModal";
import SingleLoaderItem from "../Loaders/SingleLoaderItem";
import { Dropdown } from "react-bootstrap";
import { PiPlugsConnected } from "react-icons/pi";
import LoaderOpenAction from "../Loaders/LoaderOpenAction";
import LoaderAbilityParams from "../Loaders/LoaderAbilityParams";
import TableOnlyRowsLoading from "../Loaders/TableOnlyRowsLoading";
import FormatDateTime from "../Functions/FormatDate";
import Spinner from "../Components/Spinner";
import { useLanguage } from "../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const CreateAction = ({
    account_id,
    userData,
    mcpData,
    fetchMcpData,
    loadingMcpData,
    singleOrgData
}) => {
    const {t} = useLanguage()
    const navigate = useNavigate()
    const { org_id, act_id } = useParams();
    const [actionData, setActionData] = useState({})
    const [loading, setLoading] = useState(false)
    const [loadingAbilityParams, setLoadingAbilityParams] = useState(false)
    const [loadingLogs, setLoadingLogs] = useState(false)
    const [logs, setLogs] = useState([])
    const [openLog, setOpenLog] = useState("")
    const [openSaveAction, setOpenSaveAction] = useState(false)
    const [openFieldChoise, setOpenFieldChoise] = useState("0");
    const [popupMex, setPopupMex] = useState({ active: false, type: null, message: "" });
    const [steps, setSteps] = useState([
        {
            id: Date.now(),
            step_name: "",
            ability: "",
            endpoints: []
        }
    ]);

    const toggleField = (index) => {
        const key = String(index);
        setOpenFieldChoise(prev => (prev === key ? null : key));
    };

    const handleChange = (index, e) => {
        const { name, value } = e.target;

        setSteps(prev => {
            const updated = [...prev];
            updated[index][name] = value;
            return updated;
        });
    };

    const addAction = () => {
        const newIndex = steps.length;

        setSteps(prev => [
            ...prev,
            {
                id: Date.now(),
                step_name: "",
                ability: "",
                endpoints: []
            }
        ]);

    };

    const removeAction = (index) => {
        if (steps.length === 1) return;

        const updated = steps.filter((_, i) => i !== index);
        setSteps(updated);

        setOpenFieldChoise(null);
    };

    const handleAbilitySelect = (index, ability) => {
        setSteps(prev => {
            const updated = [...prev];
            updated[index].ability = ability;
            return updated;
        });
    };

    const getCurrentAction = async () => {
        setLoading(true)
        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/get_action`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    account_id,
                    org_id,
                    act_id
                }),
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.error || "Failed to fetch");
            }
            if (result.status === "success") {
                const data = result.data;

                setActionData(data);
                fetchMcpData(org_id);
                getActionLogs()

                const normalizedSteps = (data?.steps || []).map(step => ({
                    id: step?.id || Date.now(),
                    step_name: step?.step_name || "",
                    ability: step?.ability || null,

                    endpoints: Array.isArray(step?.endpoints)
                        ? step.endpoints.map(ep => ({
                            endpoint: ep?.endpoint || "",
                            description: ep?.description || "",
                            parameters: ep?.parameters || {},
                            values: ep?.values || {}
                        }))
                        : [],

                    original_endpoints: Array.isArray(step?.original_endpoints)
                        ? step.original_endpoints.map(ep => ({
                            endpoint: ep?.endpoint || "",
                            description: ep?.description || "",
                            parameters: ep?.parameters || {},
                            values: ep?.values || {}
                        }))
                        : []
                }));

                setSteps(
                    normalizedSteps.length > 0
                        ? normalizedSteps
                        : [
                            {
                                id: Date.now(),
                                step_name: "",
                                ability: null,
                                endpoints: [],
                                original_endpoints: []
                            }
                        ]
                );
            }

            if (result.error == "not_authorized") {
                setPopupMex({ active: true, type: "error", message: "Organization auth..." })
                setTimeout(() => {
                    setPopupMex({ active: false, type: null, message: "" })
                    navigate(`/e8console/organizations`)
                }, 5000);
            }

            if (result.error == "not_found") {
                setPopupMex({ active: true, type: "error", message: "Action not found..." })
                setTimeout(() => {
                    setPopupMex({ active: false, type: null, message: "" })
                    navigate(`/e8console/organizations/${org_id}/actions`)
                }, 5000);
            }

        } catch (err) {
            setLoading(false)
            console.error("Error fetching ability params:", err);
        } finally {
            setLoading(false)
        }
    };

    const getAbilityParams = async (ability, index) => {
        setLoadingAbilityParams(true)
        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/get_mcp_params`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    account_id,
                    org_id,
                    mcp_id: ability.id,
                    version: ability.version
                }),
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.error || "Failed to fetch");
            }

            if (result.status === "success") {
                const endpoints = (result.command_input || []).map(cmd => ({
                    endpoint: cmd.endpoint,
                    description: cmd.description,
                    parameters: cmd.parameters || {},
                    values: {}
                }));

                setSteps(prev => {
                    const updated = [...prev];

                    updated[index] = {
                        ...updated[index],
                        endpoints,
                        original_endpoints: endpoints
                    };

                    return updated;
                });
            }

        } catch (err) {
            setLoadingAbilityParams(false)
            console.error("Error fetching ability params:", err);
        } finally {
            setLoadingAbilityParams(false)
        }
    };

    const getActionLogs = async () => {
        setLoadingLogs(true)
        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/get_action_logs`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    account_id,
                    act_id
                }),
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.error || "Failed to fetch");
            }
            if (result.status === "success") {
                setLogs(result.data)
            }

        } catch (err) {
            setLoadingLogs(false)
            console.error("Error fetching ability params:", err);
        } finally {
            setLoadingLogs(false)
        }
    };

    const handleParamChange = (stepIndex, endpointIndex, key, value) => {
        setSteps(prev => {
            const updated = [...prev];
            updated[stepIndex].endpoints[endpointIndex].values[key] = value;
            return updated;
        });
    };

    const removeEndpoint = (stepIndex, endpointIndex) => {
        setSteps(prev => {
            return prev.map((step, i) => {
                if (i !== stepIndex) return step;

                return {
                    ...step,
                    endpoints: step.endpoints.filter((_, idx) => idx !== endpointIndex)
                };
            });
        });
    };

    const resetEndpoints = (stepIndex) => {
        setSteps(prev => {
            return prev.map((step, i) => {
                if (i !== stepIndex) return step;

                return {
                    ...step,
                    endpoints: step.original_endpoints
                        ? step.original_endpoints.map(ep => ({
                            ...ep,
                            values: {}
                        }))
                        : []
                };
            });
        });
    };

    const selectedAbilities = steps
        .map(step => step.ability?.id)
        .filter(Boolean);

    useEffect(() => {
        getCurrentAction()
    }, [account_id, act_id])

    if (loading) {
        return <LoaderOpenAction />
    }

    return (
        <div className="main_action_cont">
            <PopupMex
                active={popupMex.active}
                type={popupMex.type}
                message={popupMex.message}
            />

            <div className="main_action_cont_inner">
                <div className="main_mcp_cont_chat_header">
                    <div className="main_mcp_cont_chat_btn_cont">
                        {loadingLogs ? (
                            <button className="main_mcp_cont_chat_p fade-in main_mcp_cont_chat_btn_loading"></button>
                        ) : (
                            actionData.name ? (
                                <p className="main_mcp_cont_chat_title fade-in">{actionData.name}</p>
                            ) : (
                                <p className="main_mcp_cont_chat_title">{t.actions.title}</p>
                            )
                        )}
                    </div>

                    <div className="main_mcp_cont_chat_btn_cont">
                        <button
                            className="main_mcp_cont_chat_btn fade-in"
                            onClick={() => setOpenSaveAction(true)}
                        >
                            <BiPlay /> {t.actions.save_run}
                        </button>
                    </div>
                </div>

                <div className="actions_cont">
                    <div className="actions_cont_inner fade-in">
                        <div className="steps_cont_actions">
                            <div className="execution_map_header">
                                <p>
                                    <TbList />
                                    {t.actions.steps}
                                </p>
                                <button className="main_mcp_cont_chat_btn" onClick={addAction}>
                                    + {t.actions.append_actions}
                                </button>

                            </div>
                            {steps.map((action, index) => (
                                <div
                                    key={action.id}
                                    className={`field_choise_cont ${openFieldChoise == String(index) && "field_choise_cont_open"}`}
                                >
                                    <div className="field_choise_cont_header">
                                        <p>{t.actions.step} {index + 1}</p>

                                        <div className="editor_terminal_header_btn_cont">
                                            {steps.length > 1 && (
                                                <button
                                                    className="main_mcp_cont_chat_btn"
                                                    onClick={() => removeAction(index)}
                                                >
                                                    <IoClose />
                                                </button>
                                            )}

                                            <button
                                                className="main_mcp_cont_chat_btn"
                                                onClick={() => toggleField(index)}
                                            >
                                                <i className={`fa-solid fa-chevron-${openFieldChoise == String(index) ? "up" : "down"}`}></i>
                                            </button>

                                        </div>
                                    </div>

                                    <div className="persona_reg">
                                        <div className="label_input">
                                            <label className="input_label">
                                                {t.title} <MandatorySign message={t.mandatory_field} />
                                            </label>
                                            <input
                                                type="text"
                                                className="register_form_first fade-in"
                                                name="step_name"
                                                value={action.step_name}
                                                autoComplete="off"
                                                onChange={(e) => handleChange(index, e)}
                                            />
                                        </div>
                                    </div>

                                    <div className="persona_reg">
                                        <div className="label_input">
                                            <label className="input_label">
                                                {t.actions.ability} <MandatorySign message={t.mandatory_field} />
                                            </label>
                                            {loadingMcpData ? (
                                                <SingleLoaderItem length={1} />
                                            ) : (
                                                <Dropdown drop="up">
                                                    <Dropdown.Toggle as="div" className="register_form_first fade-in pointer">
                                                        {action.ability?.name || "Ability"}
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu className="custom_dropdown_menu">
                                                        {(() => {
                                                            const availableAbilities = mcpData.filter(mcp => {
                                                                if (!mcp.version || !mcp.is_connected) return false;

                                                                if (action.ability?.id === mcp.id) return true;

                                                                return !selectedAbilities.includes(mcp.id);
                                                            });

                                                            return (
                                                                <div className="">
                                                                    {availableAbilities.length === 0 ? (
                                                                        <Dropdown.Item
                                                                            className="settings_link"
                                                                        >
                                                                            {t.no_data}
                                                                        </Dropdown.Item>
                                                                    ) : (
                                                                        availableAbilities.map((mcp) => (
                                                                            <Dropdown.Item
                                                                                className="settings_link"
                                                                                key={mcp.id}
                                                                                onClick={() => {
                                                                                    handleAbilitySelect(index, mcp);
                                                                                    getAbilityParams(mcp, index);
                                                                                }}
                                                                            >
                                                                                {mcp.name}
                                                                            </Dropdown.Item>
                                                                        ))
                                                                    )}
                                                                </div>
                                                            );
                                                        })()}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            )}
                                        </div>
                                    </div>

                                    {loadingAbilityParams ? (
                                        <LoaderAbilityParams length={2} />
                                    ) : (
                                        action.endpoints.length > 0 && (
                                            <div className="params_cont">
                                                <button
                                                    className="params_cont_reset_btn"
                                                    onClick={() => resetEndpoints(index)}
                                                >
                                                    <TbReload />
                                                </button>
                                                {action.endpoints?.map((ep, epIndex) => (
                                                    <div key={`${ep.endpoint}-${epIndex}`} className="endpoint_block fade-in">

                                                        <div className="endpoint_block_header">
                                                            <div className="endpoint_title">
                                                                <strong>{ep.endpoint}</strong>
                                                                <button
                                                                    className="main_mcp_cont_chat_btn"
                                                                    onClick={() => removeEndpoint(index, epIndex)}
                                                                >
                                                                    <IoClose />
                                                                </button>
                                                            </div>
                                                            <p className="endpoint_description">{ep.description}</p>
                                                        </div>

                                                        {Object.entries(ep.parameters).map(([key, param]) => (
                                                            <div className="label_input" key={key}>
                                                                <label className="input_label">
                                                                    {key}
                                                                    {param.required && (
                                                                        <MandatorySign message={t.mandatory_field} />
                                                                    )}
                                                                </label>

                                                                <input
                                                                    type="text"
                                                                    className="register_form_first fade-in"
                                                                    value={ep.values?.[key] || ""}
                                                                    onChange={(e) =>
                                                                        handleParamChange(index, epIndex, key, e.target.value)
                                                                    }
                                                                    placeholder={param.description}
                                                                />
                                                            </div>
                                                        ))}

                                                    </div>
                                                ))}
                                            </div>
                                        )
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="actions_cont_inner fade-in">
                        <div className="execution_map_header">
                            <p>
                                <TbLogs />
                                {t.actions.action_logs}
                            </p>
                            <button onClick={getActionLogs} className="main_mcp_cont_chat_btn">{loadingLogs ? <Spinner loading={true} /> : <IoReload />}</button>

                        </div>
                        <div className="execution_map">
                            {loadingLogs ? (
                                <SingleLoaderItem length={8} />
                            ) : (
                                logs.length > 0 ? (
                                    logs.map((log) => (
                                        <div key={log.id} className="terminal_cont_item">
                                            <div className="terminal_cont_item_header">
                                                <button
                                                    className="terminal_cont_item_btn"
                                                    onClick={() =>
                                                        setOpenLog(openLog === log.id ? null : log.id)
                                                    }
                                                >
                                                    {openLog === log.id ? (
                                                        <IoChevronUp />
                                                    ) : (
                                                        <IoChevronDown />
                                                    )}
                                                </button>
                                                <p className={`log_message fade-in ${log.severity == 2 ? "log_message_red" : ""}`}><span>{FormatDateTime(log.created_at)}</span>

                                                    {log.severity != 2 ? (
                                                        <> - {log.message}</>
                                                    ) : (
                                                        <> - {t.error_occurred}</>
                                                    )

                                                    } </p>
                                            </div>

                                            <div
                                                className={`terminal_cont_item_cont ${openLog === log.id ? "terminal_cont_item_cont_open" : ""
                                                    } ${openLog === log.id && log.severity == 2 ? "terminal_cont_item_cont_red" : ""}`}
                                            >
                                                <pre>
                                                    {JSON.stringify(
                                                        {
                                                            ...(log || {}),
                                                            created_at: log?.created_at
                                                                ? FormatDateTime(log.created_at)
                                                                : log?.created_at
                                                        },
                                                        null,
                                                        2
                                                    )}
                                                </pre>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="terminal_cont_item_container">
                                        <div className="no_log_terminal_cont_item">
                                            {t.no_logs}
                                        </div>
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <SaveActionsModal
                account_id={account_id}
                show={openSaveAction}
                handleClose={() => setOpenSaveAction(false)}
                actionData={actionData}
                singleOrgData={singleOrgData}
                steps={steps}
                fetchData={getCurrentAction}
            />

        </div>
    );
};

export default CreateAction;